import { render, staticRenderFns } from "./porvencer.vue?vue&type=template&id=47939fdd"
import script from "./porvencer.vue?vue&type=script&lang=js"
export * from "./porvencer.vue?vue&type=script&lang=js"
import style0 from "./porvencer.vue?vue&type=style&index=0&id=47939fdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports